<template>
  <div class="public-footer">
    <div class="footer-banner">
      <div class="banner-info">
        <img class="banner-img" src="~@/assets/images/footer-national-flag.png" alt="">
        <div class="banner-title">
          <p class="title-self">出国留学有疑问？国家、院校、专业如何选？</p>
          <p class="title-text">一对一提供留学方案，超10年以上合作经验助力千余名学生</p>
        </div>
        <div class="banner-ipt">
          <input class="ipt-self" type="text" placeholder="留下您的电话或邮箱" v-model="email" />
          <div class="ipt-btn" @click="submit">获取专属方案</div>
        </div>
      </div>
    </div>
    <div class="footer-content">
      <div class="content-lf">
        <img class="footer-logo" src="~@/assets/images/top-logo.png" alt="">
        <p class="lf-title">华咨留学品牌隶属于华咨教育科技南京有限公司，是一家专门从事自费出国留学咨询及中介服务的、教育咨询、职业规划及翻译服务的专职机构</p>
        <p class="lf-text">地址：江苏省南京市高新区星火路19号星智汇商务花园A5栋9楼</p>
        <p class="lf-text">电话：17714352173</p>
        <p class="lf-text">邮箱：huazi@istudyedu.com</p>
      </div>
      <div class="content-item">
        <div class="item-list">
          <p class="list-text" @click="goUrl('https://www.xiaohongshu.com/user/profile/5e42e0fc0000000001008d9b?xsec_token=YBVC4wGJz4vsez6GaGZ9t0MKRc29n8d3WTdidbfBlhGyQ=&xsec_source=app_share&xhsshare=WeixinSession&appuid=60a3978f000000000101ca23&apptime=1767002472&share_id=c4cc9a0832c449c68ff5c46ef96eb922&wechatWid=d05137d5b3d63e2fdada426c80063682&wechatOrigin=menu')">小红书: HZ华咨留学</p>
          <p class="list-text" @click="goUrl('https://xhslink.com/m/4szn5UJjIW7')">小红书: 德布勒森大学中国办公室</p>
          <p class="list-text" @click="goUrl('https://v.douyin.com/AZE0FKyuop8/?utm_campaign=client_share&app=aweme&utm_medium=ios&tt_from=more&utm_source=more')">抖音：匈牙利留学合作中心</p>
          <img class="list-img" src="~@/assets/images/footer-img-xyl.jpg" alt="">
          <p class="list-text te">公众号：匈牙利留学合作中心</p>
        </div>
        <div class="item-list">
          <p class="list-text" @click="goUrl('https://v.douyin.com/lYC1za1bkPo/ 1@7.com :7pm')">抖音：德布勒森大学（匈牙利）</p>
          <p class="list-text" @click="goUrl('https://www.zhihu.com/people/35-12-70-90-97')">知乎：德布勒森大学</p>
          <p class="list-text" @click="goUrl('https://www.zhihu.com/people/xiong-ya-li-liu-xue-he-zuo-zhong-xin?utm_source=wechat_session&utm_medium=social')">知乎：匈牙利留学合作</p>
          <img class="list-img" src="~@/assets/images/footer-img-dbls.jpg" alt="">
          <p class="list-text te">公众号：德布勒森大学驻华办公室</p>
        </div>
        <div class="item-list">
          <p class="list-text" @click="goUrl('https://space.bilibili.com/3494378878274112?spm_id_from=333.1007.0.0 ')">b站：德布勒森大学</p>
          <p class="list-text" @click="goUrl('https://space.bilibili.com/1801382500')">b站：匈牙利留学合作中心</p>
          <p class="list-text" style="height:42px;"></p>
          <img class="list-img" src="~@/assets/images/footer-img-mzke.jpg" alt="">
          <p class="list-text te">公众号：米什科尔茨大学</p>
        </div>
      </div>
    </div>
    <div class="footer-copyrights">
      <p class="copyright-text">Copyrights © 2022 华咨教育科技南京有限公司版权所有 All Rights Reserved / ICP备案：苏ICP备20047329号</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'public-footer',
  props: {},
  data () {
    return {
      email: ''
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {},
  methods: {
    async submit () {
      if (this.email === '') {
        this.$message.error('请输入信息')
        return
      }
      try { 
        const res = await this.$api.post('contacts/update', { email: this.email })
        if (res.code === 200) { 
          this.$message.success(res.message)
          this.email = ''
        }
      } catch (error) {}
    },
    goUrl (url) {
      if (process.client) {
        window.open(url, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.public-footer{background-color:#fff;}
.footer-banner{background:linear-gradient(to right, rgb(252, 111, 137) 0%,#ff123f 25%,rgb(252, 111, 137) 100%);}
.footer-banner .banner-info{display:flex;max-width:1200px;width:100%;margin:0 auto;align-items:center;padding:16px 0;}
.footer-banner .banner-img{display: block;width:103px;margin:0 50px 0 50px;}
.footer-banner .banner-title{padding-right:54px;}
.footer-banner .banner-title .title-self{font-size:24px;color:#fff;line-height:1.5;margin-bottom:10px;font-weight:600;}
.footer-banner .banner-title .title-text{font-size:16px;color:#fff;line-height:1.5;font-weight:400;}
.footer-banner .banner-ipt{display:flex;}
.footer-banner .banner-ipt .ipt-self{width:200px;height:42px;border:1px solid #0080E3;outline:none;border-radius:42px 0 0 42px;padding:0 10px;}
.footer-banner .banner-ipt .ipt-btn{width:100px;line-height:42px;background:#0080E3;color:#fff;cursor:pointer;font-size:14px;text-align:center;border-radius:0 42px 42px 0;}
.footer-content{max-width:1200px;width:100%;margin:0 auto;display:grid;gap:50px;padding:30px 0;grid-template-columns:400px 1fr;}
.footer-content .content-lf{width:400px;color:#808080;font-size:14px;}
.footer-content .footer-logo{width:238px;display:block;margin:0 auto 20px;}
.footer-content .content-lf .lf-title{margin-bottom:36px;line-height:2;}
.footer-content .content-lf .lf-text{line-height:2;}
.footer-content .content-item{margin-top:48px;display:grid;grid-template-columns: repeat(3, 1fr);gap:60px;color:#808080;font-size:14px;flex:1;}
.footer-content .content-item .list-text{line-height:3;cursor:pointer;}
.footer-content .content-item .list-text.te{text-align:center;font-size:12px;}
.footer-content .content-item .list-img{display: block;width:100px;margin:0 auto;}
.footer-copyrights{border-top:1px solid #E5E5E5;padding:20px 0;}
.copyright-text{max-width:1200px;width: 100%;margin: 0 auto;color: #808080;font-size: 14px;;}
</style>
